module.exports = __webpack_public_path__ + "img/intro_uk.15e14ca6.svg";